(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-frequently-bought-together"] && !Shopify.designMode) return;
  try {
    
      (() => {
      const roots = document.querySelectorAll('[data-cc-fbt-legacy-disabled]');

        roots.forEach((root) => {
          if (root.dataset.ccFbtInitialized === 'true') return;
          root.dataset.ccFbtInitialized = 'true';

        const cards = Array.from(root.querySelectorAll('[data-cc-fbt-card]'));
        const addButton = root.querySelector('[data-cc-fbt-add]');
        const status = root.querySelector('[data-cc-fbt-status]');
        const offerTitle = root.querySelector('[data-cc-fbt-offer-title]');
        const offerCopy = root.querySelector('[data-cc-fbt-offer-copy]');
        const totalLabel = root.querySelector('[data-cc-fbt-total-label]');
        const totalOutput = root.querySelector('[data-cc-fbt-total]');
        const mainVariants = JSON.parse(root.querySelector('[data-cc-fbt-main-variants]').textContent);
        const currency = window.Shopify?.currency?.active || 'USD';

        const normalize = (value) => String(value || '').trim().toLowerCase();
        const formatMoney = (cents) => new Intl.NumberFormat(
          document.documentElement.lang || 'en-US',
          { style: 'currency', currency }
        ).format(Number(cents || 0) / 100);

        const getMainForm = () => {
          const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
          return forms.find((form) => form.querySelector('input[name="id"]')) || null;
        };

        const getMainVariant = () => {
          const form = getMainForm();
          const id = form?.querySelector('input[name="id"]')?.value;
          return mainVariants.find((variant) => String(variant.id) === String(id)) || mainVariants[0];
        };

        const getMainQuantity = () => {
          const quantity = Number(getMainForm()?.querySelector('input[name="quantity"]')?.value || 1);
          return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
        };

        const selectedOption = (card) => {
          const field = card.querySelector('[data-cc-fbt-variant]');
          if (!field) return null;
          return field.tagName === 'SELECT' ? field.options[field.selectedIndex] : field;
        };

        const getCardQuantity = (card) => {
          const input = card.querySelector('[data-cc-fbt-quantity-input]');
          const quantity = Math.min(4, Math.max(1, Number(input?.value || 1)));
          if (input) input.value = quantity;
          return quantity;
        };

        const updateCard = (card) => {
          const option = selectedOption(card);
          const image = card.querySelector('[data-cc-fbt-image]');
          const price = card.querySelector('[data-cc-fbt-price]');
          const selected = card.querySelector('[data-cc-fbt-checkbox]').checked;
          if (option?.dataset.image && image) image.src = option.dataset.image;
          if (option?.dataset.alt && image) image.alt = option.dataset.alt;
          if (price) price.textContent = formatMoney(option?.dataset.price);
          card.classList.toggle('cc-fbt__card--unchecked', !selected);
          card.querySelectorAll('[data-cc-fbt-quantity] button, [data-cc-fbt-quantity] input').forEach(
            (control) => {
              control.disabled = !selected;
            }
          );
        };

        const matchAddonColors = () => {
          const mainColor = normalize(getMainVariant()?.color);
          if (!mainColor) return;
          cards.forEach((card) => {
            const select = card.querySelector('select[data-cc-fbt-variant]');
            if (!select) return;
            const match = Array.from(select.options).find(
              (option) => normalize(option.dataset.color) === mainColor
            );
            if (match) select.value = match.value;
            updateCard(card);
          });
        };

        const refresh = () => {
          const mainVariant = getMainVariant();
          const mainQuantity = getMainQuantity();
          let units = mainQuantity;
          let subtotal = Number(mainVariant?.price || 0) * mainQuantity;
          let selectedAddons = 0;

          cards.forEach((card) => {
            updateCard(card);
            if (!card.querySelector('[data-cc-fbt-checkbox]').checked) return;
            const option = selectedOption(card);
            const quantity = getCardQuantity(card);
            selectedAddons += 1;
            units += quantity;
            subtotal += Number(option?.dataset.price || 0) * quantity;
          });

          const qualifiesForDiscount = units >= 3;
          const qualifiesForShipping = subtotal >= 7000;
          const estimatedTotal = qualifiesForDiscount ? Math.round(subtotal * 0.85) : subtotal;

          totalLabel.textContent = qualifiesForDiscount ? 'Estimated after 15% off' : 'Bundle subtotal';
          totalOutput.textContent = formatMoney(estimatedTotal);

          if (qualifiesForDiscount && qualifiesForShipping) {
            offerTitle.textContent = '15% off + free U.S. shipping';
            offerCopy.textContent = 'Both rewards apply automatically in cart.';
          } else if (qualifiesForShipping) {
            offerTitle.textContent = 'Free U.S. shipping unlocked';
            const remaining = Math.max(1, 3 - units);
            offerCopy.textContent = `Add ${remaining} more ${remaining === 1 ? 'item' : 'items'} to save 15%.`;
          } else {
            offerTitle.textContent = `${formatMoney(7000 - subtotal)} away from free shipping`;
            offerCopy.textContent = 'Select a recommendation to complete your setup.';
          }

          addButton.disabled = selectedAddons === 0;
          addButton.textContent = selectedAddons === 0
            ? 'Select an add-on'
              : `Add ${units} ${units === 1 ? 'item' : 'items'} to cart`;
        };

        root.ccFbtRefresh = refresh;

        cards.forEach((card) => {
          card.querySelector('[data-cc-fbt-checkbox]').addEventListener('change', refresh);
          card.querySelector('[data-cc-fbt-variant]')?.addEventListener('change', refresh);
        });

        root.addEventListener('click', (event) => {
          const button = event.target.closest('[data-cc-fbt-quantity-change]');
          if (!button || !root.contains(button)) return;
          const card = button.closest('[data-cc-fbt-card]');
          const input = card?.querySelector('[data-cc-fbt-quantity-input]');
          if (!input) return;
          const change = Number(button.dataset.ccFbtQuantityChange || 0);
          input.value = Math.min(4, Math.max(1, Number(input.value || 1) + change));
          refresh();
        });

        root.addEventListener('input', (event) => {
          if (!event.target.matches('[data-cc-fbt-quantity-input]')) return;
          refresh();
        });

        root.addEventListener('change', (event) => {
          if (!event.target.matches('[data-cc-fbt-quantity-input]')) return;
          refresh();
        });

        document.addEventListener('change', (event) => {
          if (!event.target.closest('form[action*="/cart/add"]')) return;
          window.setTimeout(() => {
            matchAddonColors();
            refresh();
          }, 0);
        });

        document.addEventListener('variant:change', () => {
          window.setTimeout(() => {
            matchAddonColors();
            refresh();
          }, 0);
        });

        addButton.addEventListener('click', async () => {
          const mainVariant = getMainVariant();
          const selectedCards = cards.filter(
            (card) => card.querySelector('[data-cc-fbt-checkbox]').checked
          );
          if (!mainVariant || selectedCards.length === 0) return;

          const items = [
            { id: Number(mainVariant.id), quantity: getMainQuantity() },
            ...selectedCards.map((card) => ({
              id: Number(selectedOption(card).value),
              quantity: getCardQuantity(card)
            }))
          ];

          const payload = { items };

          addButton.disabled = true;
          addButton.classList.add('loading');
          addButton.textContent = 'Adding your set…';
          status.textContent = '';

          try {
            const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify(payload)
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || 'Unable to add this set.');

            status.textContent = 'Your matched set was added to cart.';
            window.location.href = window.routes?.cart_url || '/cart';
          } catch (error) {
            status.textContent = error.message || 'Something went wrong. Please try again.';
            refresh();
          } finally {
            addButton.classList.remove('loading');
            if (!status.textContent.includes('added')) refresh();
          }
        });

        matchAddonColors();
        refresh();
        });
      })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
